import { defineCustomElement, getAttribute, NectaryElement, updateAttribute } from '../utils';
const templateHTML = '<style>:host{display:inline-block}#icon{display:block;font-family:var(--sinch-comp-icon-font-family);font-weight:var(--sinch-comp-icon-font-weight);font-size:var(--sinch-global-size-icon, 24px);font-feature-settings:var(--sinch-comp-icon-font-feature-settings);-webkit-font-smoothing:antialiased;line-height:1;white-space:nowrap;width:var(--sinch-global-size-icon,24px);height:var(--sinch-global-size-icon,24px);color:var(--sinch-global-color-icon,var(--sinch-sys-color-text-default));user-select:none}</style><span id="icon" role="img"></span>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-icon', class extends NectaryElement {
  #$icon;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$icon = shadowRoot.querySelector('#icon');
  }
  static get observedAttributes() {
    return ['name'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'name':
        {
          this.#$icon.textContent = newVal;
          updateAttribute(this.#$icon, 'aria-label', newVal);
          break;
        }
    }
  }
  set name(value) {
    updateAttribute(this, 'name', value);
  }
  get name() {
    return getAttribute(this, 'name', '');
  }
});